export const statusLabels: Record<string, string> = {
  BN: 'Новая',
  IP: 'В работе',
  UR: 'Перерасчёт',
  ID: 'Спор',
  SF: 'Завершена',
  AA: 'Автоподтверждена',
  AAD: 'Одобрена в споре',
  FR: 'Завершена с перерасчётом',
  NF: 'Реквизит не найден',
  TO: 'Просрочена',
  CR: 'Отменена с перерасчётом',
  CANCELED: 'Отменена',
  STS: 'Поддержка',
  STSD: 'Спор в поддержке',
  PC: 'Проблема подтверждена',
};

export const statusTone = (status: string) => {
  if (['SF', 'AA', 'AAD', 'FR'].includes(status)) return 'success';
  if (['TO', 'NF', 'CR', 'CANCELED', 'PC', 'STS', 'STSD'].includes(status)) return 'danger';
  if (status === 'ID') return 'warning';
  return 'neutral';
};

export const formatMoney = (amount: string | number | null | undefined, currency: string) => {
  if (amount === null || amount === undefined || amount === '') return '—';
  return `${new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 6 }).format(Number(amount))} ${currency}`;
};

// статусы, по которым бэкенд принимает спор от мерчанта (DISPUTABLE_STATUSES в api/v1/serializers/support.py)
export const DISPUTABLE_STATUSES = ['SF', 'AA', 'AAD', 'FR', 'CR', 'TO', 'CANCELED'];
// активная заявка на пополнение: мерчант может отменить её через cancel_order (кроме последних секунд срока)
export const CANCELABLE_STATUSES = ['BN', 'IP'];

const legacyDate = /^(\d{2})-(\d{2})-(\d{4})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/;

/** Дата из API: ISO либо «ДД-ММ-ГГГГ ЧЧ:ММ» (так отдаёт список споров); невалидное значение не превращается в «Invalid Date». */
export const formatDateTime = (value: string | null | undefined) => {
  if (!value) return '—';
  const legacy = legacyDate.exec(value);
  const date = legacy
    ? new Date(Number(legacy[3]), Number(legacy[2]) - 1, Number(legacy[1]), Number(legacy[4] || 0), Number(legacy[5] || 0), Number(legacy[6] || 0))
    : new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString('ru-RU');
};

export const shortId = (value: string | number | null | undefined) => {
  if (value === null || value === undefined || value === '') return '—';
  const text = String(value);
  return text.length > 12 ? `${text.slice(0, 8)}…${text.slice(-4)}` : text;
};
